// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1m7Lq","loaderOuter":"PageOverlayLoader_loaderOuter__1qz0I"};